import axios from "axios";
import * as actionTypes from "./actionTypes";
import { getCurrentLogedUserData } from "./AuthAction";

const vehicleTypeFormater = (type) => {
  switch (type) {
    case "car":
      return (type = "cars");
    case "motor":
      return (type = "motors");
    case "commercial":
      return (type = "commercials");
    default:
      return "all";
  }
};

export const initGetActivityPosts = () => {
  return {
    type: actionTypes.INIT_GET_ACTIVTY_POSTS,
    loadingGetActPosts: true,
    activityPosts: null,
    activityError: null,
  };
};

export const succesGetActivityPosts = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_ACTIVTY_POSTS,
    loadingGetActPosts: false,
    activityPosts: data,
  };
};

export const failGetActivityPosts = (error) => {
  return {
    type: actionTypes.FAIL_GET_ACTIVTY_POSTS,
    loadingGetActPosts: false,
    activityError: error,
  };
};

export const getActivityPosts = (model, mode, withoutInit, page = 1) => {
  const sellerId = localStorage.getItem("uid");
  let query = null;
  switch (mode) {
    case "published":
      query = "is_published=1&is_reviewed=1&is_approved=1";
      break;
    case "reviewed":
      query = "is_published=1&is_reviewed=1&is_approved=0";
      break;
    case "onHold":
      query = "is_published=1&is_reviewed=0&is_approved=0";
      break;
    case "draft":
      query = "is_published=0&is_reviewed=0&is_approved=0";
      break;
    default:
      break;
  }
  return (dispatch) => {
    if (!withoutInit) {
      dispatch(initGetActivityPosts());
    }
    axios
      .get(
        `${model}/lists?${
          query ?? ""
        }&seller_id=${sellerId}&per_page=4&page=${page}`
      )
      .then((response) => {
        dispatch(succesGetActivityPosts(response.data));
      })
      .catch((error) => {
        dispatch(failGetActivityPosts(error.message));
      });
  };
};

// Delete activiy post:

export const deleteAcitivityPost = (id) => {
  const token = localStorage.getItem("idToken");

  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  return (dispatch) => {
    axios
      .delete(`all/lists/${id}`, config)
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => console.log(err.message));
  };
};

// get add comment:
export const initGetPostComments = () => {
  return {
    type: actionTypes.GET_POST_COMMENTS,
    loadingPostComments: true,
  };
};

export const successGetPostComments = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_POST_COMMENTS,
    loadingPostComments: false,
    postComments: data,
  };
};

export const failGetPostComments = (error) => {
  return {
    type: actionTypes.FAIL_GET_POST_COMMENTS,
    loadingPostComments: false,
    postCommentsError: error,
  };
};

export const getPostComments = (vehicleId, dontLoad) => {
  return (dispatch) => {
    if (!dontLoad) dispatch(initGetPostComments());
    axios
      .get(`all/lists/${vehicleId}/comments`)
      .then((response) => {
        dispatch(successGetPostComments(response.data.data));
      })
      .catch((error) => {
        console.log(error);
        dispatch(failGetPostComments(error.message));
      });
  };
};

//Add comment to a Published Post:

export const postAddComment = (
  mode,
  vehicleId,
  content,
  parentId,
  vType = "all"
) => {
  const token = localStorage.getItem("idToken");
  const data = {
    content: content,
    parent_comment_id: parentId,
  };
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return (dispatch) => {
    axios
      .post(`all/lists/${vehicleId}/comments`, data, config)
      .then((response) => {
        dispatch(getPostComments(vehicleId, true));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

//Purshase from pcari:

export const purchaseFromPcari = (
  vType,
  purchaseType,
  postId,
  validity,
  discountedPrice,
  mode
) => {
  const token = localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  const data = {
    validity: validity,
    discounted_price: discountedPrice,
  };
  if (!discountedPrice) {
    delete data.discounted_price;
  }
  vType = vehicleTypeFormater(vType);
  return (dispatch) => {
    axios
      .post(`${vType}/lists/${postId}/${purchaseType}`, data, config)
      .then((response) => {
        dispatch(getActivityPosts(vType, mode));
        dispatch(getCurrentLogedUserData(token));
      })
      .catch((error) => {
        console.log(error.message);
      });
  };
};

// GET  MODERATOR COMMETNS:

export const initGetModeratorComments = () => {
  return {
    type: actionTypes.GET_MODERATOR_COMMENTS,
    loadingModeratorComments: true,
  };
};

//export const successGetModeratorComments = (key, value) => {
export const successGetModeratorComments = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_MODERATOR_COMMENTS,
    loadingModeratorComments: false,
    comments: data,
  };
};

export const failGetModeratorComments = (error) => {
  return {
    type: actionTypes.FAIL_GET_MODERATOR_COMMENTS,
    loadingModeratorComments: false,
    moderatorCommentError: error,
  };
};

export const getModeratorComments = (postId) => {
  return (dispatch) => {
    dispatch(initGetModeratorComments());
    axios
      .get(`all/lists/${postId}/moderator_comments`)
      .then((response) => {
        // let filterdComments = response.data.data.filter(comment => {
        //     const currentUser = parseInt(localStorage.getItem('uid'));
        //     if (+comment.user.role_id === 1 || +comment.user.role_id === 4 || comment.user_id === currentUser) {
        //         return comment
        //     }
        //     return null
        // });
        // const key = `comments_${postId}`;
        // const val = { comments: filterdComments }
        // dispatch(successGetModeratorComments(key, val));
        dispatch(successGetModeratorComments(response.data.data));
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(failGetModeratorComments(error.message));
      });
  };
};

//Reply Moderator Comment:
export const replyToModerator = (mode, vehicleId, content, parentId) => {
  const token = localStorage.getItem("idToken");
  const data = {
    content: content,
    parent_comment_id: parentId,
  };
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };
  return (dispatch) => {
    axios
      .post(
        `all/lists/${vehicleId}/moderator_comments/${parentId}/reply`,
        data,
        config
      )
      .then((response) => {
        dispatch(getModeratorComments(vehicleId));
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

// GET Payment History:

export const initGetPaymentHistory = () => {
  return {
    type: actionTypes.INIT_GET_PAYMENT_HISTORY,
    loadingPaymentHistory: true,
  };
};

export const successGetPaymentHistory = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_PAYMENT_HISTORY,
    loadingPaymentHistory: false,
    paymentHistory: data,
  };
};

export const failGetPaymentHistory = (error) => {
  return {
    type: actionTypes.FAIL_GET_PAYMENT_HISTORY,
    loadingPaymentHistory: false,
    pymentHistoryError: error,
  };
};

export const getPaymentHistory = () => {
  const token = localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  return (dispatch) => {
    dispatch(initGetPaymentHistory());
    axios
      .get("token_transactions/mine", config)
      .then((response) => {
        dispatch(successGetPaymentHistory(response.data));
      })
      .catch((error) => {
        console.log(error.message);
        dispatch(failGetPaymentHistory(error.message));
      });
  };
};

// GET Invoices:
export const initGetInvoices = () => {
  return {
    type: actionTypes.INIT_GET_INVOICES,
    loadingInvoices: true,
  };
};

export const successGetInvoices = (data) => {
  return {
    type: actionTypes.SUCCESS_GET_INVOICES,
    loadingInvoices: false,
    invoices: data,
  };
};

export const failGetInvoices = (error) => {
  return {
    type: actionTypes.FAIL_GET_INVOICES,
    loadingInvoices: false,
    invoicesError: error,
  };
};

export const getInvocices = () => {
  const token = localStorage.getItem("idToken");
  const config = {
    headers: {
      Authorization: "Bearer " + token,
    },
  };

  return (dispatch) => {
    dispatch(initGetInvoices());
    axios
      .get("invoices", config)
      .then((response) => {
        dispatch(successGetInvoices(response.data));
      })
      .catch((error) => {
        dispatch(failGetInvoices(error.message));
      });
  };
};
